import styled, { css } from 'styled-components';

// Styled Components
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';

// Components
import { InputRadio } from '../../../../../inputs/InputRadio';

// Types

export const ContainerTable = styled(Container)`
  display: flex;
  gap: 9.8rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 3.2rem;
  }
`;

export const ActiveUsersTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  flex: 1;
  width: 57.2rem;
  max-width: 90.1rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const InactiveUsersTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  flex: 1;
  width: 57.2rem;
  max-width: 90.1rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

export const InputRadioStyled = styled(InputRadio)``;

export const SwapUserButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) =>
    theme.colors.garnet}; /* CAMBIO: Color principal ROIS */
`;

export const SwapUserButtonLeft = styled(SwapUserButton)`
  align-self: end;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    align-self: flex-start;
  }
`;
